import React from 'react';
import {interpolate, useCurrentFrame} from 'remotion';
import {ArrowRight, Timer as TimerIcon} from 'lucide-react';
import {brandFont} from '../../brand';
import {InputModeToggle} from '../app/InputModeToggle';
import {InputPromptCard} from '../app/InputPromptCard';
import {CreateTimerButton} from '../app/CreateTimerButton';
import {CreatingStatusLine} from '../app/CreatingStatusLine';

const SAVED_TIMERS: [string, string][] = [
  ['Leg Day Burner', '18 min'],
  ['Saturday EMOM', '24 min'],
  ['Core Finisher', '12 min'],
];

export const Story1Prompt: React.FC<{morphAtFrame?: number}> = ({
  morphAtFrame = 57,
}) => {
  const frame = useCurrentFrame();
  const isCreating = frame >= morphAtFrame;
  const filledOpacity = interpolate(
    frame,
    [morphAtFrame - 6, morphAtFrame + 6],
    [0, 1],
    {extrapolateRight: 'clamp', extrapolateLeft: 'clamp'},
  );
  const emptyOpacity = 1 - filledOpacity;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 22,
      }}
    >
      <InputModeToggle selected="write" />
      <InputPromptCard
        filledText={'For time:\n4 rounds\n12 DB snatches\n10 burpees\nRest 45 sec between rounds'}
        emptyOpacity={emptyOpacity}
        filledOpacity={filledOpacity}
      />
      <CreateTimerButton isCreating={isCreating} frame={frame} />
      <SavedTimersHeader />
      <SavedTimersRow />
      <CreatingStatusLine visible={isCreating} />
    </div>
  );
};

const SavedTimersHeader: React.FC = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontFamily: brandFont,
      fontSize: 22,
      color: 'rgba(255,255,255,0.72)',
      fontWeight: 600,
    }}
  >
    <span>Saved timers</span>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 18,
        color: 'rgba(255,255,255,0.48)',
      }}
    >
      View all
      <ArrowRight size={18} color="rgba(255,255,255,0.38)" strokeWidth={2.4} />
    </div>
  </div>
);

const SavedTimersRow: React.FC = () => (
  <div style={{display: 'flex', gap: 14}}>
    {SAVED_TIMERS.map(([title, dur]) => (
      <div
        key={title}
        style={{
          flex: 1,
          padding: 16,
          background: 'rgba(255,255,255,0.06)',
          borderRadius: 22,
          border: '1.5px solid rgba(255,255,255,0.05)',
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
        }}
      >
        <div
          style={{
            fontFamily: brandFont,
            fontSize: 18,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.9)',
            lineHeight: 1.2,
          }}
        >
          {title}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontFamily: brandFont,
            fontSize: 16,
            color: 'rgba(255,255,255,0.46)',
          }}
        >
          <TimerIcon size={14} color="rgba(255,255,255,0.42)" strokeWidth={2.4} />
          {dur}
        </div>
      </div>
    ))}
  </div>
);
